import React from "react";

var Add16x16 = function Add16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14 6h-4V2a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v4H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4v4a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-4h4a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1Z"
  }));
};

Add16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Add24x24 = function Add24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M21 10h-7V3c0-.6-.4-1-1-1h-2c-.6 0-1 .4-1 1v7H3c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h7v7c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-7h7c.6 0 1-.4 1-1v-2c0-.6-.4-1-1-1z"
  }));
};

Add24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var Alert16x16 = function Alert16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.45 14a2.5 2.5 0 0 1-4.9 0h4.9ZM8 0a5.91 5.91 0 0 1 5.98 5.36l.01.22.01.22v3.6l.95 2.6.03.08.01.09v.09c0 .31-.19.59-.51.7l-.12.03-.11.02H1.75a.75.75 0 0 1-.74-.76v-.13l.04-.13L2 9.41V5.57A5.9 5.9 0 0 1 8 0Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
};

Alert16x16.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  focusable: "false"
};

var Alert24x24 = function Alert24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15.69 21a3.75 3.75 0 0 1-7.36 0h7.36ZM12 0c4.72 0 8.62 3.5 8.98 8.03l.02.33v5.74L22.45 18l.03.12.03.13v.14c0 .47-.29.88-.78 1.06l-.17.05-.17.01H2.63a1.12 1.12 0 0 1-1.11-1.14v-.18l.05-.2L3 14.12V8.35C3.2 3.68 7.17 0 12 0Z",
    fill: "currentColor"
  }));
};

Alert24x24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  focusable: "false"
};

var AlertOutline16x16 = function AlertOutline16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 5.8v3.6l.95 2.6.03.08.01.09.01.09c0 .31-.2.59-.52.7l-.12.03-.11.02h-2.37a4 4 0 0 1-7.75 0H1.74a.75.75 0 0 1-.74-.76v-.13l.04-.13.95-2.58V5.57A5.9 5.9 0 0 1 8 0a5.92 5.92 0 0 1 6 5.36v.22l.01.22ZM6.27 13a2 2 0 0 0 3.47 0H6.27Zm6.19-2H3.53L4 9.78V5.63A3.9 3.9 0 0 1 8 2a3.92 3.92 0 0 1 4 3.5v4.26l.47 1.25Z",
    fill: "currentColor"
  }));
};

AlertOutline16x16.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  focusable: "false"
};

var AllItems16x16 = function AllItems16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11 2H5L0 8.67V13a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V8.67Zm-1 6.67V9.8a1 1 0 0 1-1 1.07H7A1 1 0 0 1 6 9.8V8.67H2.36L6 4h4l3.68 4.67Z"
  }));
};

AllItems16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var AllItems24x24 = function AllItems24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M18 5H6L0 15h24L18 5zM0 15v4a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-4m-2.32 0H16v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2H2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5A1.5 1.5 0 0 1 8.5 16v-1.5H3.11l1.89-3h14l1.86 3H15.5V16a1.5 1.5 0 0 1-1.5 1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 12 20 14h-5v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-2H4l1.24-2h13.5m.56-1H4.69l-.29.47-1.24 2L2.21 15H8v1a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-1h5.79l-.95-1.53-1.24-2-.29-.47Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.97 11.5 1.87-3h10.32l1.87 3H4.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.88 9 1.25 2H5.87l1.25-2h9.76m.55-1H6.57l-.29.47-1.28 2L4.07 12h15.86l-1-1.53-1.25-2-.25-.47Z",
    fill: "#fff"
  }));
};

AllItems24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var Analytics16x16 = function Analytics16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M2 14h13a1 1 0 0 1 1 1 1 1 0 0 1-1 1H0V1a1 1 0 0 1 1-1 1 1 0 0 1 1 1Zm4-8H4v7h2Zm3-3H7v10h2Zm3 2h-2v8h2Z"
  }));
};

Analytics16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var ArrowDown16x16 = function ArrowDown16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.78 5.29 8.24 8.83 4.71 5.29a1 1 0 0 0-1.41 0 1 1 0 0 0 0 1.41l3.54 3.54 1.41 1.41 1.41-1.41L13.2 6.7a1 1 0 0 0 0-1.41 1 1 0 0 0-1.42 0Z"
  }));
};

ArrowDown16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var ArrowLeft16x16 = function ArrowLeft16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.28 11.54 6.74 8l3.54-3.54a1 1 0 0 0 0-1.41 1 1 0 0 0-1.41 0L5.33 6.59 3.91 8l1.42 1.41 3.54 3.54a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41Z"
  }));
};

ArrowLeft16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var ArrowRight16x16 = function ArrowRight16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6.21 4.46 9.74 8l-3.53 3.54a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l3.54-3.54L12.57 8l-1.41-1.41-3.54-3.54a1 1 0 0 0-1.41 0 1 1 0 0 0 0 1.41Z"
  }));
};

ArrowRight16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var ArrowUp16x16 = function ArrowUp16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m4.71 11 3.53-3.5 3.54 3.5a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.41l-3.53-3.5-1.42-1.42-1.41 1.42-3.54 3.53a1 1 0 0 0 0 1.41A1 1 0 0 0 4.71 11Z"
  }));
};

ArrowUp16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Audio16x16 = function Audio16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9 10.85a1 1 0 0 1 .63-1 2 2 0 0 0 0-3.8 1 1 0 0 1-.63-1 1 1 0 0 1 1.26-.94 4 4 0 0 1 0 7.6A1 1 0 0 1 9 10.85Zm1.11-9.77a1 1 0 0 0-.28 1.98 5 5 0 0 1 0 9.86 1 1 0 0 0-.83 1 1 1 0 0 0 1.11 1 7 7 0 0 0 0-13.82v-.02Zm-3.73.22L3 5H1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h2l3.38 3.7A1 1 0 0 0 8 13.92V2.08a1 1 0 0 0-1.62-.78Z"
  }));
};

Audio16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Audio20x20 = function Audio20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.26 13.7c-.02-.27.04-.55.19-.78.14-.23.35-.41.6-.52.5-.17.93-.5 1.24-.94a2.67 2.67 0 0 0 0-3.05 2.5 2.5 0 0 0-1.25-.94c-.24-.1-.45-.29-.6-.52-.14-.23-.2-.5-.18-.78a1.34 1.34 0 0 1 .5-1.01 1.23 1.23 0 0 1 1.07-.21c1 .34 1.87 1 2.5 1.89a5.34 5.34 0 0 1 0 6.1 5.02 5.02 0 0 1-2.5 1.88 1.2 1.2 0 0 1-1.03-.18 1.28 1.28 0 0 1-.54-.94ZM12.64 1a1.2 1.2 0 0 0-.96.33 1.3 1.3 0 0 0-.42.95c0 .31.1.61.28.85.2.24.46.4.75.45a6.2 6.2 0 0 1 3.74 2.21 6.65 6.65 0 0 1 0 8.4 6.2 6.2 0 0 1-3.74 2.2c-.29.06-.56.22-.75.45-.19.24-.29.54-.28.85a1.34 1.34 0 0 0 .41.98 1.24 1.24 0 0 0 .97.32 8.68 8.68 0 0 0 5.27-3.08A9.31 9.31 0 0 0 20 10c0-2.16-.74-4.25-2.09-5.9a8.68 8.68 0 0 0-5.27-3.08v-.02Zm-4.66.3L3.5 6h-2C.67 6 0 6.67 0 7.5v5c0 .83.67 1.5 1.5 1.5h2l4.48 4.7a1.23 1.23 0 0 0 1.32.16 1.34 1.34 0 0 0 .7-1.16V2.3c0-.24-.06-.47-.19-.68a1.21 1.21 0 0 0-1.83-.33Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))));
};

Audio20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var Audio24x24 = function Audio24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.4 2.2 5 7H1a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h4l5.47 4a1 1 0 0 0 1.53-.8V3a1 1 0 0 0-1.6-.8ZM14 20.94a1 1 0 0 1 .87-1 8 8 0 0 0 0-15.94A1 1 0 0 1 14 3a1 1 0 0 1 1.12-1 10 10 0 0 1 0 19.88 1 1 0 0 1-1.12-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 16.89a1 1 0 0 1 .83-1 4 4 0 0 0 0-7.83 1 1 0 0 1-.83-1 1 1 0 0 1 1.15-1 6 6 0 0 1 0 11.78 1 1 0 0 1-1.15-1Z"
  }));
};

Audio24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var AudioDescription16x16 = function AudioDescription16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.84 6.4c1 0 1.79.72 1.79 1.6 0 .88-.8 1.6-1.79 1.6h-.46V6.4h.46ZM6.81 8.95H5.26l1.55-2.14v2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.1 2.6c.23-.4.66-.6 1.13-.6h11.54c.47 0 .9.2 1.12.6C15.34 3.45 16 5.16 16 8c0 2.85-.66 4.56-1.1 5.4-.23.4-.66.6-1.13.6H2.23c-.47 0-.9-.2-1.12-.6C.66 12.55 0 10.84 0 8c0-2.85.66-4.56 1.1-5.4Zm9.93 8.4c1.85 0 3.35-1.35 3.35-3 0-1.66-1.49-3-3.34-3H8.97v6h2.06Zm-2.76 0H6.8v-.8H4.34l-.56.8H1.62l4.82-6h1.83v6Z",
    clipRule: "evenodd"
  }));
};

AudioDescription16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var AudioDescription20x20 = function AudioDescription20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.52 10.96H3.97L5.52 8.8v2.15ZM11.34 10c0-.88-.8-1.6-1.79-1.6H9.1v3.2h.46c1 0 1.79-.72 1.79-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.24 3C1.48 3 .8 3.44.6 4.17.33 5.25 0 7.13 0 10s.33 4.75.6 5.83c.2.73.88 1.17 1.64 1.17h15.52c.76 0 1.44-.44 1.63-1.17.28-1.08.61-2.96.61-5.83s-.33-4.75-.6-5.83C19.2 3.44 18.51 3 17.75 3H2.24Zm11.75 4h-1.17c.93.83 1.5 1.83 1.5 3 0 1.05-.73 2.2-1.47 3H14c.8-.85 1.3-1.97 1.3-3 0-1.15-.46-2.13-1.3-3Zm2.27 0h-1.11a4.7 4.7 0 0 1 1.11 3c0 .9-.37 2.12-1.11 3h1.11a5.3 5.3 0 0 0 .97-3c0-.86-.28-2.1-.97-3Zm1 0h1.11c.69.9.75 2.14.75 3 0 .87-.02 2.13-.7 3h-1.1c.74-.88.83-2.1.83-3 0-.9-.17-2.31-.9-3ZM6.98 13H5.51v-.8H3.05l-.56.8H.33l4.82-6h1.83v6Zm6.11-3c0 1.65-1.5 3-3.35 3H7.68V7h2.07c1.85 0 3.34 1.35 3.34 3Z",
    clipRule: "evenodd"
  }));
};

AudioDescription20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var AudioLow16x16 = function AudioLow16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6.4 1.2 3 4.9H1c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1h2l3.4 3.7c.4.3 1.1.3 1.4-.2.1-.2.2-.4.2-.6V2c0-.6-.5-1-1-1-.2 0-.4.1-.6.2Z"
  }));
};

AudioLow16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var AudioLow20x20 = function AudioLow20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.5 5.99 4.48-4.71a1.23 1.23 0 0 1 1.83.33c.13.2.2.44.2.68v15.39c0 .24-.07.48-.2.69-.12.2-.3.37-.51.47a1.2 1.2 0 0 1-1.32-.15L3.5 14h-2a1.5 1.5 0 0 1-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5h2Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))));
};

AudioLow20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var AudioMedium16x16 = function AudioMedium16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9 10.85a1 1 0 0 1 .63-1 2 2 0 0 0 0-3.8 1 1 0 0 1-.63-1 1 1 0 0 1 1.26-.94 4 4 0 0 1 0 7.6A1 1 0 0 1 9 10.85ZM6.38 1.3 3 5H1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h2l3.38 3.7A1 1 0 0 0 8 13.92V2.08a1 1 0 0 0-1.62-.78Z"
  }));
};

AudioMedium16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var AudioMedium20x20 = function AudioMedium20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.26 13.7c-.02-.27.04-.55.19-.78.14-.23.35-.41.6-.52.5-.17.93-.5 1.24-.94a2.67 2.67 0 0 0 0-3.05c-.31-.44-.75-.77-1.25-.94-.24-.1-.45-.29-.6-.52-.14-.23-.2-.5-.18-.78a1.34 1.34 0 0 1 .5-1.01 1.23 1.23 0 0 1 1.07-.21c1 .34 1.87 1 2.5 1.89a5.34 5.34 0 0 1 0 6.1 5.02 5.02 0 0 1-2.5 1.88 1.2 1.2 0 0 1-1.03-.18 1.28 1.28 0 0 1-.54-.94ZM7.98 1.3 3.5 6h-2C.67 6 0 6.67 0 7.5v5c0 .83.67 1.5 1.5 1.5h2l4.48 4.7a1.23 1.23 0 0 0 1.32.16 1.34 1.34 0 0 0 .7-1.16V2.3c0-.24-.06-.47-.19-.68a1.21 1.21 0 0 0-1.83-.33Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))));
};

AudioMedium20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var AudioMuted16x16 = function AudioMuted16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m3 4.9 3.4-3.7c.2-.1.4-.2.6-.2.5 0 1 .4 1 1v11.8c0 .2-.1.4-.2.6-.3.5-1 .5-1.4.2L3 10.9H1c-.6 0-1-.4-1-1v-4c0-.6.4-1 1-1h2ZM10.5 5.5a.7.7 0 0 0 0 1L12 8l-1.5 1.5a.7.7 0 0 0 1 1L13 9l1.5 1.5a.7.7 0 0 0 1-1L14 8l1.5-1.5a.7.7 0 0 0-1-1L13 7l-1.5-1.5a.7.7 0 0 0-1 0Z"
  }));
};

AudioMuted16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var AudioMuted20x20 = function AudioMuted20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.98 1.28 3.5 5.98h-2c-.83 0-1.5.68-1.5 1.5v5c0 .83.67 1.5 1.5 1.5h2l4.48 4.71a1.23 1.23 0 0 0 1.83-.32c.13-.2.2-.45.2-.7V2.3c0-.24-.07-.48-.2-.68a1.21 1.21 0 0 0-1.83-.33ZM12.86 6.88a.88.88 0 0 0 0 1.25L14.73 10l-1.87 1.88a.88.88 0 1 0 1.25 1.24l1.87-1.87 1.88 1.88a.88.88 0 1 0 1.25-1.26L17.23 10l1.88-1.88a.88.88 0 1 0-1.25-1.24l-1.88 1.87-1.87-1.88a.88.88 0 0 0-1.25 0Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))));
};

AudioMuted20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var AudioMuted24x24 = function AudioMuted24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m782 563 1-1 2 2 2-2 1 1-2 2 2 2-1 1-2-2-2 2-1-1 2-2-2-2zM13.7 9l1.7-1.7 3.4 3.4 3.4-3.4L24 9l-3.4 3.4 3.4 3.4-1.7 1.7-3.4-3.4-3.4 3.4-1.7-1.7 3.4-3.4L13.7 9zM10.4 2.1 5 6.9H1c-.6 0-1 .4-1 1v9c0 .6.4 1 1 1h4l5.5 4c.5.3 1.1.2 1.4-.3.1-.1.1-.3.2-.5V2.9c0-.6-.4-1-1-1-.3 0-.5.1-.7.2z"
  }));
};

AudioMuted24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var Calendar16x16 = function Calendar16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M16 2v3H0V2a1 1 0 0 1 1-1h1v1a2 2 0 0 0 4 0V1h4v1a2 2 0 0 0 4 0V1h1a1 1 0 0 1 1 1ZM0 15a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V6H0ZM4 0a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0V1a1 1 0 0 0-1-1Zm8 0a1 1 0 0 0-1 1v1a1 1 0 0 0 2 0V1a1 1 0 0 0-1-1Z"
  }));
};

Calendar16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Calendar24x24 = function Calendar24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M24 3v3H0V3a1 1 0 0 1 1-1h2v1a2 2 0 0 0 4 0V2h10v1a2 2 0 0 0 4 0V2h2a1 1 0 0 1 1 1ZM0 22a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V7H0ZM20 1a1 1 0 0 0-2 0v2a1 1 0 0 0 2 0Zm-1-1a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V1a1 1 0 0 0-1-1ZM6 1a1 1 0 0 0-2 0v2a1 1 0 0 0 2 0ZM5 0a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V1a1 1 0 0 0-1-1Z"
  }));
};

Calendar24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var Camera16x16 = function Camera16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15 3h-3V2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v1H1a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1Zm-5 7a2.5 2.5 0 1 1 .5-1.5A2.49 2.49 0 0 1 10 10Z"
  }));
};

Camera16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var CaptionAdd24x24 = function CaptionAdd24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1 5c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5zM0 5v8c0 1.7 1.3 3 3 3h16c1.7 0 3-1.3 3-3V5c0-1.7-1.3-3-3-3H3C1.3 2 0 3.3 0 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 10h11v1H4v-1zM4 7h14v1H4V7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 18v-4h-4v-4h-4v4h-4v4h4v4h4v-4h4z"
  }));
};

CaptionAdd24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var CaptionDelete24x24 = function CaptionDelete24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1 5c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5zM0 5v8c0 1.7 1.3 3 3 3h16c1.7 0 3-1.3 3-3V5c0-1.7-1.3-3-3-3H3C1.3 2 0 3.3 0 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 10h14v1H4v-1zM4 7h14v1H4V7zM23.7 14.8 20.8 12 18 14.8 15.2 12l-2.8 2.8 2.8 2.8-2.8 2.8 2.8 2.8 2.8-2.8 2.8 2.8 2.8-2.8-2.8-2.8 2.9-2.8z"
  }));
};

CaptionDelete24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var CaptionSplit24x24 = function CaptionSplit24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9 3H5V2h4a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H5v-1h4c.6 0 1-.5 1-1V4c0-.5-.4-1-1-1zM15 21h4v1h-4a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h4v1h-4a1 1 0 0 0-1 1v16c0 .5.4 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 16 5-4-5-4v3h-3v2h3v3zM5 8l-5 4 5 4v-3h3v-2H5V8z"
  }));
};

CaptionSplit24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var Captions16x16 = function Captions16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14 2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2ZM5.06 9.75A1.43 1.43 0 0 0 6.31 9l1 .47a2.47 2.47 0 0 1-2.23 1.31A2.71 2.71 0 0 1 2.22 8a2.71 2.71 0 0 1 2.84-2.76 2.46 2.46 0 0 1 2.23 1.3L6.31 7a1.43 1.43 0 0 0-1.25-.77A1.66 1.66 0 0 0 3.39 8a1.66 1.66 0 0 0 1.67 1.75Zm6.49 0A1.46 1.46 0 0 0 12.81 9l1 .47a2.45 2.45 0 0 1-2.23 1.31A2.71 2.71 0 0 1 8.71 8a2.71 2.71 0 0 1 2.84-2.76 2.43 2.43 0 0 1 2.23 1.3l-1 .48a1.46 1.46 0 0 0-1.26-.77A1.66 1.66 0 0 0 9.88 8a1.66 1.66 0 0 0 1.67 1.75Z"
  }));
};

Captions16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var CaratDown16x16 = function CaratDown16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4 5h8l-4 6-4-6z"
  }));
};

CaratDown16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var CaratLeft16x16 = function CaratLeft16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11 4v8L5 8l6-4z"
  }));
};

CaratLeft16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var CaratRight16x16 = function CaratRight16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5 12V4l6 4-6 4z"
  }));
};

CaratRight16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var CaratUp16x16 = function CaratUp16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 11H4l4-6 4 6z"
  }));
};

CaratUp16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Checkmark16x16 = function Checkmark16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m15 2.4-.6-.6a1 1 0 0 0-1.5.1l-6.7 9.7-2.9-2.9a1 1 0 0 0-1.4 0l-.6.6a1 1 0 0 0 0 1.4L6.6 16l8.5-12.3a.94.94 0 0 0-.1-1.3Z"
  }));
};

Checkmark16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var CircleAdd16x16 = function CircleAdd16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11 7H9V5c0-.5-.5-1-1-1s-1 .5-1 1v2H5c-.5 0-1 .5-1 1s.5 1 1 1h2v2c0 .5.5 1 1 1s1-.5 1-1V9h2c.5 0 1-.5 1-1s-.5-1-1-1zM8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 14c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6z"
  }));
};

CircleAdd16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var CircleAdd24x24 = function CircleAdd24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M17 11h-4V7c0-.5-.5-1-1-1s-1 .5-1 1v4H7c-.5 0-1 .5-1 1s.5 1 1 1h4v4c0 .5.5 1 1 1s1-.5 1-1v-4h4c.5 0 1-.5 1-1s-.5-1-1-1zM12 1C5.9 1 1 5.9 1 12s4.9 11 11 11 11-5 11-11S18 1 12 1zm0 20c-5 0-9-4.1-9-9s4-9 9-9 9 4 9 9-4.1 9-9 9z"
  }));
};

CircleAdd24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var CircleRemove16x16 = function CircleRemove16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11 7H5c-.5 0-1 .5-1 1s.5 1 1 1h6c.5 0 1-.5 1-1s-.5-1-1-1zM8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 14c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6z"
  }));
};

CircleRemove16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var CircleRemove24x24 = function CircleRemove24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M17 11H7c-.5 0-1 .5-1 1s.5 1 1 1h10c.5 0 1-.5 1-1s-.5-1-1-1zM12 1C5.9 1 1 5.9 1 12s4.9 11 11 11 11-5 11-11S18 1 12 1zm0 20c-5 0-9-4.1-9-9s4-9 9-9 9 4 9 9-4.1 9-9 9z"
  }));
};

CircleRemove24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var Close16x16 = function Close16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m10.12 8 4.24-4.24a1 1 0 0 0 0-1.41l-.71-.71a1 1 0 0 0-1.41 0L8 5.88 3.76 1.64a1 1 0 0 0-1.41 0l-.71.71a1 1 0 0 0 0 1.41L5.88 8l-4.24 4.24a1 1 0 0 0 0 1.41l.71.71a1 1 0 0 0 1.41 0L8 10.12l4.24 4.24a1 1 0 0 0 1.41 0l.71-.71a1 1 0 0 0 0-1.41Z"
  }));
};

Close16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Close20x20 = function Close20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m12.15 10 4.9-4.9a1.52 1.52 0 1 0-2.15-2.16L10 7.85l-4.9-4.9a1.52 1.52 0 1 0-2.16 2.14L7.85 10l-4.9 4.9a1.52 1.52 0 0 0 2.14 2.16L10 12.15l4.9 4.9a1.52 1.52 0 1 0 2.15-2.15l-4.9-4.9Z"
  }));
};

Close20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var Close24x24 = function Close24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m14.58 12 5.88-5.89a1.82 1.82 0 0 0-2.58-2.58L12 9.42 6.12 3.53a1.82 1.82 0 1 0-2.59 2.58L9.42 12l-5.89 5.89a1.82 1.82 0 1 0 2.58 2.58L12 14.58l5.88 5.88a1.82 1.82 0 1 0 2.58-2.58Z"
  }));
};

Close24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var ClosedCaption16x16 = function ClosedCaption16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.6 2C.72 2 0 2.72 0 3.6v8.8c0 .88.72 1.6 1.6 1.6h12.8c.88 0 1.6-.72 1.6-1.6V3.6c0-.88-.72-1.6-1.6-1.6H1.6Zm3.86 9c1.1 0 1.78-.47 2.18-1.02l-.81-.76c-.32.44-.76.68-1.32.68C4.47 9.9 3.8 9.1 3.8 8c0-1.12.68-1.9 1.72-1.9.56 0 1 .23 1.32.68l.81-.76A2.56 2.56 0 0 0 5.46 5 2.87 2.87 0 0 0 2.5 8c0 1.73 1.22 3 2.96 3Zm8.18-1.02A2.56 2.56 0 0 1 11.46 11 2.87 2.87 0 0 1 8.5 8c0-1.73 1.22-3 2.96-3 1.1 0 1.78.47 2.18 1.02l-.81.76a1.52 1.52 0 0 0-1.32-.68c-1.04 0-1.72.78-1.72 1.9 0 1.1.68 1.9 1.72 1.9.56 0 1-.24 1.32-.68l.81.76Z",
    clipRule: "evenodd"
  }));
};

ClosedCaption16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var ClosedCaption20x20 = function ClosedCaption20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 5c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5Zm6.7 8.5c1.3 0 2.08-.55 2.55-1.19l-.95-.88c-.37.51-.88.79-1.53.79-1.22 0-2.02-.93-2.02-2.23 0-1.3.8-2.2 2.02-2.2.65 0 1.16.26 1.53.78l.95-.88A2.99 2.99 0 0 0 6.7 6.5 3.34 3.34 0 0 0 3.25 10c0 2.02 1.42 3.5 3.45 3.5Zm7.5 0c1.3 0 2.08-.55 2.55-1.19l-.95-.88c-.37.51-.88.79-1.53.79-1.22 0-2.02-.93-2.02-2.23 0-1.3.8-2.2 2.02-2.2.65 0 1.16.26 1.53.78l.95-.88A2.99 2.99 0 0 0 14.2 6.5a3.34 3.34 0 0 0-3.45 3.5c0 2.02 1.42 3.5 3.45 3.5Z",
    clipRule: "evenodd"
  }));
};

ClosedCaption20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var ClosedCaptionNonEng16x16 = function ClosedCaptionNonEng16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 3.7C0 2.76.72 2 1.6 2h12.8c.88 0 1.6.76 1.6 1.7v9.6c0 .94-.72 1.7-1.6 1.7H1.6C.72 15 0 14.24 0 13.3V3.7ZM2 9a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1Zm6-1a1 1 0 0 0 0 2h5a1 1 0 1 0 0-2H8Zm-6 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm10-1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2h-1Z",
    clipRule: "evenodd"
  }));
};

ClosedCaptionNonEng16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var ClosedCaptionNonEng20x20 = function ClosedCaptionNonEng20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 5c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5Zm2 6a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm7-1a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H9Zm-7 4a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm11-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z",
    clipRule: "evenodd"
  }));
};

ClosedCaptionNonEng20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var ClosedCaptions16x16 = function ClosedCaptions16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14 2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2ZM5.06 9.75A1.43 1.43 0 0 0 6.31 9l1 .47a2.47 2.47 0 0 1-2.23 1.31A2.71 2.71 0 0 1 2.22 8a2.71 2.71 0 0 1 2.84-2.76 2.46 2.46 0 0 1 2.23 1.3L6.31 7a1.43 1.43 0 0 0-1.25-.77A1.66 1.66 0 0 0 3.39 8a1.66 1.66 0 0 0 1.67 1.75Zm6.49 0A1.46 1.46 0 0 0 12.81 9l1 .47a2.45 2.45 0 0 1-2.23 1.31A2.71 2.71 0 0 1 8.71 8a2.71 2.71 0 0 1 2.84-2.76 2.43 2.43 0 0 1 2.23 1.3l-1 .48a1.46 1.46 0 0 0-1.26-.77A1.66 1.66 0 0 0 9.88 8a1.66 1.66 0 0 0 1.67 1.75Z"
  }));
};

ClosedCaptions16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Collection16x16 = function Collection16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6 7H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1Zm0-1ZM2 2v4h4V2ZM14 7h-4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1Zm0-1Zm-4-4v4h4V2ZM6 15H2a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1Zm0-1Zm-4-4v4h4v-4ZM14 15h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1Zm0-1Zm-4-4v4h4v-4Z"
  }));
};

Collection16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Comment16x16 = function Comment16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15 1H1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7l5 3v-3h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1Z"
  }));
};

Comment16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Comment24x24 = function Comment24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M20 3H4a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h11l5 4v-4a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3Z"
  }));
};

Comment24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var Copy16x16 = function Copy16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v9H2a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1Zm8 1H6a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1Z"
  }));
};

Copy16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Delete16x16 = function Delete16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15 3v1H1V3a1 1 0 0 1 1-1h3l1-2h4l1 2h3a1 1 0 0 1 1 1Zm-4 11h-1V5H6v9H5V5H2v9a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5h-3Z"
  }));
};

Delete16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Document16x16 = function Document16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6.8 6H2l6-6v4.8A1.2 1.2 0 0 1 6.8 6ZM13 0H9v4.8A2.21 2.21 0 0 1 6.8 7H2v8a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1Z"
  }));
};

Document16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Document24x24 = function Document24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 2v20a1 1 0 0 1-1 1h-15a1 1 0 0 1-1-1V9h6a2 2 0 0 0 2-2V1h8a1 1 0 0 1 1 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.5 1-7 7h6a1 1 0 0 0 1-1V1"
  }));
};

Document24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var Documents24x24 = function Documents24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M22 1v16a1 1 0 0 1-1 1h-1V4a2 2 0 0 0-2-2H8V1a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 4v16a1 1 0 0 1-1 1h-1V7a2 2 0 0 0-2-2H5V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "2",
    y: "6",
    width: "14",
    height: "18",
    rx: "1",
    ry: "1"
  }));
};

Documents24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var Download16x16 = function Download16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 13 3 6h3V1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5h3Zm8 2a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1 1 1 0 0 0 1 1h14a1 1 0 0 0 1-1Z"
  }));
};

Download16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Edit16x16 = function Edit16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14.78 4.71 6.49 13l-3-3 8.29-8.29a1 1 0 0 1 1.41 0l1.59 1.59a1 1 0 0 1 0 1.41ZM2.49 11l-1 4 4-1Z"
  }));
};

Edit16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Ellipsis16x16 = function Ellipsis16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 8A1.75 1.75 0 1 1 8 6.25 1.75 1.75 0 0 1 9.75 8ZM13 6.25A1.75 1.75 0 1 0 14.75 8 1.75 1.75 0 0 0 13 6.25Zm-10 0A1.75 1.75 0 1 0 4.75 8 1.75 1.75 0 0 0 3 6.25Z"
  }));
};

Ellipsis16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Ellipsis24x24 = function Ellipsis24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 12a2 2 0 1 1-2-2 2 2 0 0 1 2 2Zm4-2a2 2 0 1 0 2 2 2 2 0 0 0-2-2Zm6 0a2 2 0 1 0 2 2 2 2 0 0 0-2-2Z"
  }));
};

Ellipsis24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var EllipsisStacked16x16 = function EllipsisStacked16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 9.8C7 9.8 6.2 9 6.2 8S7 6.2 8 6.2 9.8 7 9.8 8 9 9.8 8 9.8zM9.8 13c0-1-.8-1.8-1.8-1.8S6.2 12 6.2 13 7 14.8 8 14.8 9.8 14 9.8 13zm0-10C9.8 2 9 1.2 8 1.2S6.2 2 6.2 3 7 4.8 8 4.8 9.8 4 9.8 3z"
  }));
};

EllipsisStacked16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  width: "16",
  height: "16",
  focusable: "false"
};

var Emoji16x16 = function Emoji16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3 5c.5 0 1 .5 1 1s-.5 1-1 1-1-.5-1-1 .5-1 1-1zM5 5c.5 0 1 .5 1 1s-.4 1-1 1-1-.4-1-1 .5-1 1-1zm3 8c-2 0-3.8-1.2-4.6-3h1.1c.7 1.2 2 2 3.5 2s2.8-.8 3.5-2h1.1c-.7 1.8-2.5 3-4.6 3z"
  }));
};

Emoji16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Folder16x16 = function Folder16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15 3H7L5.83 1H1.17A1.09 1.09 0 0 0 0 2v12a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1Z"
  }));
};

Folder16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Folder24x24 = function Folder24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M22.25 4h-10l-2-3H3.41A3.75 3.75 0 0 0 .48 2.31 1.89 1.89 0 0 0 0 3.5v16.75A1.75 1.75 0 0 0 1.75 22h20.5A1.75 1.75 0 0 0 24 20.25V5.75A1.75 1.75 0 0 0 22.25 4Z"
  }));
};

Folder24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var FolderAdd16x16 = function FolderAdd16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15 3H7L5.83 1H1.17A1.09 1.09 0 0 0 0 2v12a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1Zm-3 7H9v3H7v-3H4V8h3V5h2v3h3Z"
  }));
};

FolderAdd16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var FolderMove16x16 = function FolderMove16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15 3H7L5.83 1H1.17A1.09 1.09 0 0 0 0 2v12a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1Zm-7 9v-2H5a1 1 0 0 1 0-2h3V6l4 3Z"
  }));
};

FolderMove16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Free16x16 = function Free16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-0)",
    transform: "translate(-52)"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(54 10)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(61 10)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(53 6)",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(61 6)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "translate(54)",
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h5v6H1a1 1 0 0 1-1-1V0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M0 0h5v5a1 1 0 0 1-1 1H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 1a1 1 0 0 1 1-1h5v3H1a1 1 0 0 1-1-1V1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M0 0h5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M0 3a3 3 0 0 0 3 3h6a3 3 0 1 0-3-3 3 3 0 0 0-6 0zm2 .5C2 4.5 2.5 5 3.5 5H5V3.5C5 2.5 4.5 2 3.5 2S2 2.5 2 3.5zm8 0c0 1-.5 1.5-1.5 1.5H7V3.5C7 2.5 7.5 2 8.5 2s1.5.5 1.5 1.5z",
    fillRule: "evenodd"
  })));
};

Free16x16.defaultProps = {
  viewBox: "0 0 16 16",
  width: "16",
  height: "16",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  focusable: "false"
};

var FullscreenEnter16x16 = function FullscreenEnter16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6 1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1 1 1 0 0 0 1-1V2h3a1 1 0 0 0 1-1ZM10 1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1 1 1 0 0 1-1-1V2h-3a1 1 0 0 1-1-1ZM6 15a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1 1 1 0 0 1 1 1v3h3a1 1 0 0 1 1 1ZM10 15a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1 1 1 0 0 0-1 1v3h-3a1 1 0 0 0-1 1Z"
  }));
};

FullscreenEnter16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  focusable: "false"
};

var FullscreenExit16x16 = function FullscreenExit16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 5a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1 1 1 0 0 0-1 1v3H1a1 1 0 0 0-1 1ZM16 5a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1 1 1 0 0 1 1 1v3h3a1 1 0 0 1 1 1ZM0 11a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1 1 1 0 0 1-1-1v-3H1a1 1 0 0 1-1-1ZM16 11a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-3h3a1 1 0 0 0 1-1Z"
  }));
};

FullscreenExit16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  focusable: "false"
};

var Groups16x16 = function Groups16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2.5C10.5 3.9 9.4 5 8 5S5.5 3.9 5.5 2.5 6.6 0 8 0s2.5 1.1 2.5 2.5zM13 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM2 7a2 2 0 0 0-2 2v5c0 .6.4 1 1 1h3V7H2zm12 0h-2v8h3c.6 0 1-.4 1-1V9a2 2 0 0 0-2-2zM3 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7 4H6c-.6 0-1 .4-1 1v8c0 .6.4 1 1 1h4c.6 0 1-.4 1-1V7c0-.6-.4-1-1-1z"
  }));
};

Groups16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Hidden16x16 = function Hidden16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m12.94 5.18-2 2A2.75 2.75 0 0 1 11 8a3 3 0 0 1-3 3 2.76 2.76 0 0 1-.77-.11l-1.34 1.34a6.76 6.76 0 0 0 2.11.34c4.42 0 8-4.57 8-4.57a15.57 15.57 0 0 0-3.06-2.82ZM8 3.43C3.58 3.43 0 8 0 8a15.57 15.57 0 0 0 3.06 2.82l2-2.05A2.75 2.75 0 0 1 5 8a3 3 0 0 1 3-3 2.75 2.75 0 0 1 .77.11l1.34-1.34A6.76 6.76 0 0 0 8 3.43ZM14.01 2.7l-7.75 7.75-1.4 1.4-2.16 2.16-.71-.71L13.3 1.99l.71.71z"
  }));
};

Hidden16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Image16x16 = function Image16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15 0H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1Zm-1 14H2V2h12Zm-1-9-4.72 5.14L6.49 8 3 11.67V13h10ZM4.5 3A1.5 1.5 0 1 0 6 4.5 1.5 1.5 0 0 0 4.5 3Z"
  }));
};

Image16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Image24x24 = function Image24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M22 1H2a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1Zm-1 20H3V3h18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 10-7.55 6.43-2.86-2.74L4 18.33V20h16V10z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "7",
    r: "2"
  }));
};

Image24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var Info24x24 = function Info24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1Zm1 16h-2v-7h2Zm0-8h-2V7h2Z"
  }));
};

Info24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var Key16x16 = function Key16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m14 12.39-6-6a3.68 3.68 0 1 0-1.4 1.42l3.87 3.87-.71.71-.71-.71-1.4 1.42 2.83 2.83 1.41-1.41-.71-.71.71-.71.71.71a1 1 0 0 0 1.4-1.42ZM3.4 6a2 2 0 1 1 2.83 0A2 2 0 0 1 3.4 6Z"
  }));
};

Key16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Like16x16 = function Like16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("rect", {
    x: "1",
    y: "6",
    width: "3",
    height: "9",
    rx: "1",
    ry: "1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.91 4.49.68-2.19a1 1 0 0 0-1-1.3H9.41a1 1 0 0 0-.71.29L5.64 5.18A3 3 0 0 0 5 7v6a2 2 0 0 0 2 2h5a2 2 0 0 0 1.6-.8C15.16 12.12 16 10.6 16 8V7a1 1 0 0 0-1-1h-3.23a1 1 0 0 1-.86-1.51Z"
  }));
};

Like16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Lock16x16 = function Lock16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13 7V6A5 5 0 1 0 3 6v1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1Zm-4 4a1 1 0 0 1-2 0v-1a1 1 0 0 1 2 0Zm2-4H5V6a3 3 0 0 1 6 0Z"
  }));
};

Lock16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var MediaControlBack16x16 = function MediaControlBack16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15 2.83v10.34c0 .15-.03.29-.1.42a.8.8 0 0 1-.28.3.73.73 0 0 1-.77 0L5.39 8.72a.8.8 0 0 1-.29-.3.87.87 0 0 1 0-.83.8.8 0 0 1 .29-.3l8.46-5.18a.73.73 0 0 1 .77 0 .8.8 0 0 1 .28.3c.07.13.1.27.1.42ZM4 13a1 1 0 1 1-2 0V3a1 1 0 0 1 2 0v10Z"
  }));
};

MediaControlBack16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var MediaControlBack20x20 = function MediaControlBack20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5 15.5a1.5 1.5 0 0 1-3 0v-11a1.5 1.5 0 1 1 3 0v11ZM18 3.96v12.08a1 1 0 0 1-.12.48.94.94 0 0 1-.34.35.9.9 0 0 1-.92 0L6.47 10.84a.94.94 0 0 1-.34-.36 1 1 0 0 1 .34-1.32l10.15-6.03a.9.9 0 0 1 .92 0c.14.08.26.2.34.35a1 1 0 0 1 .12.48Z"
  }));
};

MediaControlBack20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var MediaControlBrokenPlay16x16 = function MediaControlBrokenPlay16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M3.18 14.96a.9.9 0 0 0 .2-.09l10.15-6.03a1 1 0 0 0 0-1.67l-1.6-.96-8.75 8.75ZM9.27 4.63l-5.89-3.5a.9.9 0 0 0-.92 0 .94.94 0 0 0-.34.35 1 1 0 0 0-.12.48v9.94l7.27-7.27ZM1.35 14.67a.5.5 0 0 1 0-.71l12.4-12.39a.5.5 0 1 1 .7.7L2.06 14.68a.5.5 0 0 1-.7 0Z"
  }));
};

MediaControlBrokenPlay16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var MediaControlBrokenPlay20x20 = function MediaControlBrokenPlay20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.21 18.41a1.14 1.14 0 0 0 1.02-.07l12.69-7.32A1.16 1.16 0 0 0 18.5 10a1.18 1.18 0 0 0-.58-1.02L15.2 7.42l-11 11ZM11.62 5.35l-6.39-3.7a1.14 1.14 0 0 0-1.58.44c-.1.17-.15.38-.15.58v10.8l8.12-8.12ZM1.21 18.76a1 1 0 0 1 0-1.42L16.7 1.87a1 1 0 0 1 1.41 1.41L2.63 18.76a1 1 0 0 1-1.42 0Z"
  }));
};

MediaControlBrokenPlay20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var MediaControlForward16x16 = function MediaControlForward16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1 13.17V2.83c0-.15.03-.29.1-.42a.8.8 0 0 1 .28-.3.73.73 0 0 1 .77 0l8.46 5.17a.8.8 0 0 1 .29.3.87.87 0 0 1 0 .83.8.8 0 0 1-.29.3L2.15 13.9a.73.73 0 0 1-.77 0 .8.8 0 0 1-.28-.3.87.87 0 0 1-.1-.42ZM12 3a1 1 0 1 1 2 0v10a1 1 0 1 1-2 0V3Z"
  }));
};

MediaControlForward16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var MediaControlForward20x20 = function MediaControlForward20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15 4.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0v-11ZM2 16.04V3.96a1 1 0 0 1 .12-.48c.08-.14.2-.27.34-.35a.9.9 0 0 1 .92 0l10.15 6.03a1 1 0 0 1 0 1.67L3.38 16.88a.9.9 0 0 1-.92 0 .94.94 0 0 1-.34-.35 1 1 0 0 1-.12-.48Z"
  }));
};

MediaControlForward20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var MediaControlPause16x16 = function MediaControlPause16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2ZM2 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V2Z"
  }));
};

MediaControlPause16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var MediaControlPause20x20 = function MediaControlPause20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5h-2a1.5 1.5 0 0 1-1.5-1.5v-13ZM3 3.5C3 2.67 3.67 2 4.5 2h2C7.33 2 8 2.67 8 3.5v13c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 0 1 3 16.5v-13Z"
  }));
};

MediaControlPause20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var MediaControlPlay16x16 = function MediaControlPlay16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M2 14.04V1.96a1 1 0 0 1 .12-.48c.08-.14.2-.27.34-.35a.9.9 0 0 1 .92 0l10.15 6.03a1 1 0 0 1 0 1.67L3.38 14.88a.9.9 0 0 1-.92 0 .94.94 0 0 1-.34-.35 1 1 0 0 1-.12-.48Z"
  }));
};

MediaControlPlay16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var MediaControlPlay20x20 = function MediaControlPlay20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M3 17.33V2.67a1.18 1.18 0 0 1 .57-1.01 1.14 1.14 0 0 1 1.16 0l12.69 7.32A1.16 1.16 0 0 1 18 10a1.18 1.18 0 0 1-.58 1.02L4.73 18.34a1.14 1.14 0 0 1-1.58-.43c-.1-.17-.15-.38-.15-.58Z"
  }));
};

MediaControlPlay20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var MediaControlSkipBack16x16 = function MediaControlSkipBack16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2.83v10.34c0 .15-.03.29-.1.42a.8.8 0 0 1-.28.3.73.73 0 0 1-.77 0L6.39 8.72a.8.8 0 0 1-.29-.3.87.87 0 0 1 0-.83.8.8 0 0 1 .29-.3l8.46-5.18a.73.73 0 0 1 .77 0 .8.8 0 0 1 .28.3c.07.13.1.27.1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 2.83v10.34c0 .15-.03.29-.1.42a.8.8 0 0 1-.28.3.73.73 0 0 1-.77 0L.39 8.72a.8.8 0 0 1-.29-.3.87.87 0 0 1 0-.83.8.8 0 0 1 .29-.3L8.85 2.1a.73.73 0 0 1 .77 0 .8.8 0 0 1 .28.3c.07.13.1.27.1.42Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z",
    transform: "rotate(180 8 8)"
  }))));
};

MediaControlSkipBack16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var MediaControlSkipBack20x20 = function MediaControlSkipBack20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 3.96v12.08c0 .16-.04.33-.12.48a.93.93 0 0 1-.32.35.83.83 0 0 1-.89 0l-9.72-6.03a.92.92 0 0 1-.33-.36 1.03 1.03 0 0 1 0-.96c.08-.15.2-.27.33-.36l9.72-6.03a.83.83 0 0 1 .89 0c.13.08.25.2.32.35.08.15.12.32.12.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.96v12.08a1 1 0 0 1-.12.48.94.94 0 0 1-.34.35.9.9 0 0 1-.92 0L.47 10.84a.94.94 0 0 1-.34-.36 1 1 0 0 1 .34-1.32l10.15-6.03a.9.9 0 0 1 .92 0c.14.08.26.2.34.35a1 1 0 0 1 .12.48Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z",
    transform: "rotate(180 10 10)"
  }))));
};

MediaControlSkipBack20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var MediaControlSkipBack24x24 = function MediaControlSkipBack24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m1.5 13.5 11 6.3a.9.9 0 0 0 .5.1 1 1 0 0 0 1-1v-3.4l7.5 4.3a.9.9 0 0 0 .5.1 1 1 0 0 0 1-1V6.3a.75.75 0 0 0-.1-.5 1.11 1.11 0 0 0-1.4-.4L14 9.8V6.3a.75.75 0 0 0-.1-.5 1.11 1.11 0 0 0-1.4-.4l-11 6.3a.78.78 0 0 0-.4.4 1.11 1.11 0 0 0 .4 1.4Z"
  }));
};

MediaControlSkipBack24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var MediaControlSkipForward16x16 = function MediaControlSkipForward16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.83v10.34c0 .15.03.29.1.42a.8.8 0 0 0 .28.3.73.73 0 0 0 .77 0L6 10.93v2.24c0 .15.03.29.1.42a.8.8 0 0 0 .28.3.73.73 0 0 0 .77 0l8.46-5.17a.8.8 0 0 0 .29-.3.87.87 0 0 0 0-.83.8.8 0 0 0-.29-.3L7.15 2.1a.73.73 0 0 0-.77 0 .8.8 0 0 0-.28.3.87.87 0 0 0-.1.42v2.25L1.15 2.1a.73.73 0 0 0-.77 0 .8.8 0 0 0-.28.3.87.87 0 0 0-.1.42Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }))));
};

MediaControlSkipForward16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var MediaControlSkipForward20x20 = function MediaControlSkipForward20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.04V3.96c0-.16.04-.33.12-.48a.93.93 0 0 1 .32-.35.83.83 0 0 1 .89 0l9.72 6.03c.14.09.25.2.33.36a1.03 1.03 0 0 1 0 .96.93.93 0 0 1-.33.36l-9.72 6.03a.83.83 0 0 1-.89 0 .93.93 0 0 1-.32-.35 1.03 1.03 0 0 1-.12-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16.04V3.96a1 1 0 0 1 .12-.48c.08-.14.2-.27.34-.35a.9.9 0 0 1 .92 0l10.15 6.03a1 1 0 0 1 0 1.67L9.38 16.88a.9.9 0 0 1-.92 0 .94.94 0 0 1-.34-.35 1 1 0 0 1-.12-.48Z"
  }));
};

MediaControlSkipForward20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var MediaControlSkipForward24x24 = function MediaControlSkipForward24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m22.5 11.4-11-6.3c-.2 0-.3-.1-.5-.1a1 1 0 0 0-1 1v3.4L2.5 5.2C2.3 5.1 2.2 5 2 5a1 1 0 0 0-1 1v12.6a.75.75 0 0 0 .1.5 1.11 1.11 0 0 0 1.4.4l7.5-4.3v3.4a.75.75 0 0 0 .1.5 1.11 1.11 0 0 0 1.4.4l11-6.3a.78.78 0 0 0 .4-.4 1.11 1.11 0 0 0-.4-1.4Z"
  }));
};

MediaControlSkipForward24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var MediaExpand16x16 = function MediaExpand16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10 3a1 1 0 0 0 1 1h1.5L8.89 7.61a1 1 0 0 0 1.41 1.42l3.61-3.62V7a1 1 0 1 0 2 0V3.5c0-.83-.67-1.5-1.5-1.5H11a1 1 0 0 0-1 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2H2.5a.5.5 0 0 0-.5.5v7c0 .28.22.5.5.5h11a.5.5 0 0 0 .5-.5V11a1 1 0 1 1 2 0v2a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V3Z"
  }));
};

MediaExpand16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var MediaExpand20x20 = function MediaExpand20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3H10a1 1 0 1 1 0 2H2.75a.75.75 0 0 0-.75.75v8.5c0 .41.34.75.75.75h14.5c.41 0 .75-.34.75-.75V13a1 1 0 1 1 2 0v2.5c0 .83-.67 1.5-1.5 1.5h-17A1.5 1.5 0 0 1 0 15.5v-11C0 3.67.67 3 1.5 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4a1 1 0 0 0 1 1h2.09l-4.71 4.7a1 1 0 0 0 1.41 1.42L18 6.42v1.95a1 1 0 1 0 2 0V4.5c0-.83-.67-1.5-1.5-1.5h-4a1 1 0 0 0-1 1Z"
  }));
};

MediaExpand20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var MediaFullFrame16x16 = function MediaFullFrame16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5 1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0V2h2a1 1 0 0 0 1-1ZM12 16a1 1 0 1 1 0-2h2v-2a1 1 0 1 1 2 0v3a1 1 0 0 1-1 1h-3Z"
  }));
};

MediaFullFrame16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var MediaFullFrame20x20 = function MediaFullFrame20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2a1 1 0 0 0-1-1h-4C1.67 1 1 1.67 1 2.5v4a1 1 0 0 0 2 0V3h3.5a1 1 0 0 0 1-1ZM13.5 19a1 1 0 1 1 0-2H17v-3.5a1 1 0 1 1 2 0V18a1 1 0 0 1-1 1h-4.5Z"
  }));
};

MediaFullFrame20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var MediaFullscreen16x16 = function MediaFullscreen16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5 1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0V2h2a1 1 0 0 0 1-1ZM5 15a1 1 0 0 0-1-1H2v-2a1 1 0 1 0-2 0v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1ZM12 16a1 1 0 1 1 0-2h2v-2a1 1 0 1 1 2 0v3a1 1 0 0 1-1 1h-3ZM12 2a1 1 0 1 1 0-2h3a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V2h-2Z"
  }));
};

MediaFullscreen16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var MediaFullscreen20x20 = function MediaFullscreen20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2a1 1 0 0 0-1-1h-4C1.67 1 1 1.67 1 2.5v4a1 1 0 0 0 2 0V3h3.5a1 1 0 0 0 1-1ZM7.5 18a1 1 0 0 0-1-1H3v-3.5a1 1 0 1 0-2 0v4c0 .83.67 1.5 1.5 1.5h4a1 1 0 0 0 1-1ZM13.5 19a1 1 0 1 1 0-2H17v-3.5a1 1 0 1 1 2 0V18a1 1 0 0 1-1 1h-4.5ZM13.5 3a1 1 0 1 1 0-2h4c.83 0 1.5.67 1.5 1.5v4a1 1 0 1 1-2 0V3h-3.5Z"
  }));
};

MediaFullscreen20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var MediaMinimize16x16 = function MediaMinimize16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14 10a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-2h2a1 1 0 0 0 1-1ZM3 11a1 1 0 1 1 0-2h3a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-2H3ZM3 7a1 1 0 1 1 0-2h2V3a1 1 0 0 1 2 0v3a1 1 0 0 1-1 1H3ZM14 6a1 1 0 0 0-1-1h-2V3a1 1 0 1 0-2 0v3a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1Z"
  }));
};

MediaMinimize16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var MediaMinimize20x20 = function MediaMinimize20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12a1 1 0 0 0-1-1h-4c-.83 0-1.5.67-1.5 1.5v4a1 1 0 1 0 2 0V13h3.5a1 1 0 0 0 1-1ZM17.5 8a1 1 0 0 0-1-1H13V3.5a1 1 0 1 0-2 0v4c0 .83.67 1.5 1.5 1.5h4a1 1 0 0 0 1-1ZM3.5 9a1 1 0 0 1 0-2H7V3.5a1 1 0 1 1 2 0v4C9 8.33 8.33 9 7.5 9h-4ZM3.5 13a1 1 0 1 1 0-2h4c.83 0 1.5.67 1.5 1.5v4a1 1 0 1 1-2 0V13H3.5Z"
  }));
};

MediaMinimize20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var MediaMinimizeFullFrame16x16 = function MediaMinimizeFullFrame16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14 10a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-2h2a1 1 0 0 0 1-1ZM3 7a1 1 0 1 1 0-2h2V3a1 1 0 0 1 2 0v3a1 1 0 0 1-1 1H3Z"
  }));
};

MediaMinimizeFullFrame16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var MediaMinimizeFullFrame20x20 = function MediaMinimizeFullFrame20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12a1 1 0 0 0-1-1h-4c-.83 0-1.5.67-1.5 1.5v4a1 1 0 1 0 2 0V13h3.5a1 1 0 0 0 1-1ZM3.5 9a1 1 0 1 1 0-2H7V3.5a1 1 0 0 1 2 0v4C9 8.33 8.33 9 7.5 9h-4Z"
  }));
};

MediaMinimizeFullFrame20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var MediaPopout16x16 = function MediaPopout16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H1Zm1.5 2a.5.5 0 0 0-.5.5v7c0 .28.22.5.5.5h11a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-11Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7.25c0-.14.11-.25.25-.25h5.5c.14 0 .25.11.25.25v3.5c0 .14-.11.25-.25.25h-5.5a.25.25 0 0 1-.25-.25v-3.5Z"
  }));
};

MediaPopout16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var MediaPopout20x20 = function MediaPopout20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9 9.75c0-.41.34-.75.75-.75h6.5c.41 0 .75.34.75.75v3.5c0 .41-.34.75-.75.75h-6.5a.75.75 0 0 1-.75-.75v-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 4.5C0 3.67.67 3 1.5 3h17c.83 0 1.5.67 1.5 1.5v11c0 .83-.67 1.5-1.5 1.5h-17A1.5 1.5 0 0 1 0 15.5v-11Zm2 1.25c0-.41.34-.75.75-.75h14.5c.41 0 .75.34.75.75v8.5c0 .41-.34.75-.75.75H2.75a.75.75 0 0 1-.75-.75v-8.5Z",
    clipRule: "evenodd"
  }));
};

MediaPopout20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var Playlist24x24 = function Playlist24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M16 20v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1v10a2 2 0 0 0 2 2m3-3a2 2 0 0 1-2-2V5H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1ZM21 2H9a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Zm-8 10V6l5 3Z"
  }));
};

Playlist24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var PrivacyLink16x16 = function PrivacyLink16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.8 10.8c.4.4 1 .4 1.4 0l4.6-4.6c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L4.8 9.3c-.4.4-.4 1.1 0 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8 10.6 5.3 13c-.4.4-.9.6-1.4.6-.6 0-1.1-.2-1.5-.7-.7-.8-.5-2 .2-2.8l2.3-2.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4-.1L1.3 8.6c-1.6 1.6-1.7 4.4 0 5.9.8.7 1.7 1 2.7 1 1 0 2.1-.4 2.8-1.2L9.2 12c.4-.4.4-1 0-1.4s-1.1-.4-1.4 0zM14.5 1.2C13-.5 10.2-.4 8.6 1.2L6.3 3.5c-.3.4-.3 1 0 1.4.4.4 1 .4 1.4 0L10 2.6c.7-.7 2-.9 2.8-.2a1.93 1.93 0 0 1 .1 2.9l-2.4 2.4c-.4.4-.4 1 0 1.4s1 .4 1.4 0l2.4-2.4c.9-.7 1.3-1.7 1.3-2.8 0-.9-.4-1.9-1.1-2.7z"
  }));
};

PrivacyLink16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  focusable: "false"
};

var PrivacyOrgAll16x16 = function PrivacyOrgAll16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15 5H8V1c0-.6-.4-1-1-1H1C.4 0 0 .4 0 1v15h16V6c0-.6-.4-1-1-1zM3 14H2v-2h1v2zm0-5H2V7h1v2zm0-5H2V2h1v2zm3 10H5v-2h1v2zm0-5H5V7h1v2zm0-5H5V2h1v2zm5 10h-1v-2h1v2zm0-5h-1V7h1v2zm3 5h-1v-2h1v2zm0-5h-1V7h1v2z"
  }));
};

PrivacyOrgAll16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  focusable: "false"
};

var PrivacyOrgLink16x16 = function PrivacyOrgLink16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15 4H8V1c0-.6-.4-1-1-1H1C.4 0 0 .4 0 1v9h16V5c0-.6-.4-1-1-1zM3 8H2V6h1v2zm0-4H2V2h1v2zm3 4H5V6h1v2zm0-4H5V2h1v2zm5 4h-1V6h1v2zm3 0h-1V6h1v2zM6 15H4c-.8 0-1.5-.7-1.5-1.5S3.2 12 4 12h2c.3 0 .5-.2.5-.5S6.3 11 6 11H4c-1.4 0-2.5 1.1-2.5 2.5S2.6 16 4 16h2c.3 0 .5-.2.5-.5S6.3 15 6 15zM12 11h-2c-.3 0-.5.2-.5.5s.2.5.5.5h2c.8 0 1.5.7 1.5 1.5S12.8 15 12 15h-2c-.3 0-.5.2-.5.5s.2.5.5.5h2c1.4 0 2.5-1.1 2.5-2.5S13.4 11 12 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 13.5c0 .3.2.5.5.5h7c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-7c-.3 0-.5.2-.5.5z"
  }));
};

PrivacyOrgLink16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  focusable: "false"
};

var Publish16x16 = function Publish16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.5 7.5c-.4.4-1 .4-1.4 0L9 6.4V12c0 .6-.4 1-1 1s-1-.4-1-1V6.4L5.9 7.5c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l2.8-2.8c.4-.4 1-.4 1.4 0l2.8 2.8c.4.4.4 1 0 1.4z"
  }));
};

Publish16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  focusable: "false"
};

var Question16x16 = function Question16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm-.25 11.24a.87.87 0 0 0-.9.88c0 .5.4.88.9.88s.9-.38.9-.88-.4-.87-.9-.87zM7.99 3c-1.36 0-2.4.57-2.8 1.51a1.8 1.8 0 0 0-.19.8c0 .41.24.66.66.66.34 0 .55-.15.69-.57.22-.74.76-1.15 1.58-1.15.9 0 1.53.55 1.53 1.35 0 .62-.26 1.02-.95 1.47l-.17.1c-.88.54-1.3 1.12-1.3 1.99v.15c0 .45.23.8.7.8.45 0 .65-.29.69-.72.03-.67.26-1.02 1.14-1.53.9-.54 1.43-1.26 1.43-2.32C11 4.04 9.77 3 8 3z"
  }));
};

Question16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Quiz16x16 = function Quiz16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14 1H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h4l2 3 2-3h4a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2ZM8.62 11H7.4V9.78h1.22Zm1.69-5.23a2.41 2.41 0 0 1-.21.49 2.45 2.45 0 0 1-.31.41L9.45 7l-.35.34a2.67 2.67 0 0 0-.31.36 2.1 2.1 0 0 0-.22.42 1.61 1.61 0 0 0-.08.51v.43h-.94v-.49a2.24 2.24 0 0 1 .18-.79 2.39 2.39 0 0 1 .36-.57 4 4 0 0 1 .45-.47A4.66 4.66 0 0 0 9 6.29a1.87 1.87 0 0 0 .32-.52 1.52 1.52 0 0 0 .1-.7A1.4 1.4 0 0 0 9 4.13a1.26 1.26 0 0 0-.94-.34 1.45 1.45 0 0 0-.68.14 1.37 1.37 0 0 0-.48.38 1.65 1.65 0 0 0-.28.58 2.65 2.65 0 0 0-.09.71h-.92a2.74 2.74 0 0 1 .16-1 2.31 2.31 0 0 1 .49-.85A2.2 2.2 0 0 1 7 3.16a2.63 2.63 0 0 1 1-.2 2.77 2.77 0 0 1 1 .15 2 2 0 0 1 .73.43 1.79 1.79 0 0 1 .48.69 2.27 2.27 0 0 1 .17.93 1.92 1.92 0 0 1-.07.61Z"
  }));
};

Quiz16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Redo16x16 = function Redo16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 5v1.96c0 .42.48.65.81.39l3.7-2.96a.5.5 0 0 0 0-.78L8.81.65a.5.5 0 0 0-.81.39V3a6 6 0 1 0 6 6 1 1 0 1 0-2 0 4 4 0 1 1-4-4Z"
  }));
};

Redo16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Redo20x20 = function Redo20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10 6.25v2.71c0 .42.48.65.81.39l4.95-3.96a.5.5 0 0 0 0-.78L10.81.65a.5.5 0 0 0-.81.39v2.71a7.5 7.5 0 1 0 7.5 7.5 1.25 1.25 0 1 0-2.5 0 5 5 0 1 1-5-5Z"
  }));
};

Redo20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var Redo24x24 = function Redo24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 8v2.94a.75.75 0 0 0 1.22.58l5.55-4.44a.75.75 0 0 0 0-1.17l-5.55-4.44a.75.75 0 0 0-1.22.59V5a9 9 0 1 0 9 9 1.5 1.5 0 0 0-3 0 6 6 0 1 1-6-6z"
  }));
};

Redo24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var Search16x16 = function Search16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m14.83 12.83-2.71-2.71A5.91 5.91 0 0 0 13 7a6 6 0 1 0-6 6 5.91 5.91 0 0 0 3.12-.88l2.71 2.71a1 1 0 0 0 1.41 0l.59-.59a1 1 0 0 0 0-1.41ZM3 7a4 4 0 1 1 4 4 4 4 0 0 1-4-4Z"
  }));
};

Search16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Search20x20 = function Search20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.5 16a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Zm0-2.5a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.8 11.69 4.24 4.13a1.5 1.5 0 0 1-2.1 2.14l-4.25-4.15 2.12-2.12Z"
  }));
};

Search20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var Settings16x16 = function Settings16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15.24 9.19a1 1 0 0 0 .76-.97v-.44a1 1 0 0 0-.76-.97l-.87-.21a1.13 1.13 0 0 1-.76-.72 5.3 5.3 0 0 0-.14-.36c-.16-.33-.17-.72.02-1.03l.48-.82a1 1 0 0 0-.16-1.22l-.26-.26a1 1 0 0 0-1.22-.16l-.82.48c-.31.19-.7.18-1.03.02a5.3 5.3 0 0 0-.36-.14c-.34-.13-.63-.4-.72-.76L9.2.76A1 1 0 0 0 8.22 0h-.44a1 1 0 0 0-.97.76l-.21.87c-.1.36-.38.63-.72.76l-.36.14c-.33.16-.72.17-1.03-.02l-.82-.48a1 1 0 0 0-1.22.16l-.26.26a1 1 0 0 0-.16 1.22l.48.82c.19.31.18.7.02 1.03l-.14.36c-.13.34-.4.63-.76.72l-.87.21a1 1 0 0 0-.76.97v.44a1 1 0 0 0 .76.97l.87.21c.36.1.63.38.76.72l.14.36c.16.33.17.72-.02 1.03l-.48.82a1 1 0 0 0 .16 1.22l.26.26a1 1 0 0 0 1.22.16l.82-.48c.31-.19.7-.18 1.03-.02l.36.14c.34.13.63.4.72.76l.21.87a1 1 0 0 0 .97.76h.44a1 1 0 0 0 .97-.76l.21-.87c.1-.36.38-.63.72-.76l.36-.14c.33-.16.72-.17 1.03.02l.82.48a1 1 0 0 0 1.22-.16l.26-.26a1 1 0 0 0 .16-1.22l-.48-.82c-.19-.31-.18-.7-.02-1.03l.14-.36c.13-.34.4-.63.76-.72l.87-.21ZM8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"
  }));
};

Settings16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Settings20x20 = function Settings20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M18.86 11.53A1.5 1.5 0 0 0 20 10.08v-.16a1.5 1.5 0 0 0-1.14-1.45l-1.04-.26a1.1 1.1 0 0 1-.75-.72 6.61 6.61 0 0 0-.3-.72 1.1 1.1 0 0 1 .02-1.03l.58-1a1.5 1.5 0 0 0-.24-1.8l-.06-.07a1.5 1.5 0 0 0-1.82-.24l-.99.58c-.31.19-.7.18-1.03.02a6.6 6.6 0 0 0-.72-.3 1.1 1.1 0 0 1-.72-.75l-.26-1.04A1.5 1.5 0 0 0 10.08 0h-.16a1.5 1.5 0 0 0-1.45 1.14L8.2 2.18a1.1 1.1 0 0 1-.72.75c-.25.09-.49.19-.72.3a1.1 1.1 0 0 1-1.03-.02l-1-.58a1.5 1.5 0 0 0-1.8.24l-.07.06a1.5 1.5 0 0 0-.24 1.82l.58.99c.19.31.18.7.02 1.03-.11.23-.21.47-.3.72-.12.35-.4.63-.75.72l-1.04.26A1.5 1.5 0 0 0 0 9.92v.16c0 .69.47 1.29 1.14 1.45l1.04.26c.36.1.63.37.75.72.09.25.19.49.3.72.16.33.17.72-.02 1.03l-.58 1a1.5 1.5 0 0 0 .24 1.8l.06.07a1.5 1.5 0 0 0 1.82.24l.99-.58c.31-.19.7-.18 1.03-.02.23.11.47.21.72.3.35.12.63.4.72.75l.26 1.04A1.5 1.5 0 0 0 9.92 20h.16a1.5 1.5 0 0 0 1.45-1.14l.26-1.04c.1-.36.37-.63.72-.75.25-.09.49-.19.72-.3a1.1 1.1 0 0 1 1.03.02l1 .58a1.5 1.5 0 0 0 1.8-.24l.07-.06a1.5 1.5 0 0 0 .24-1.82l-.58-.99a1.1 1.1 0 0 1-.02-1.03c.11-.23.21-.47.3-.72.12-.35.4-.63.75-.72l1.04-.26ZM10 13.75a3.75 3.75 0 1 1 0-7.5 3.75 3.75 0 0 1 0 7.5Z"
  }));
};

Settings20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var Settings24x24 = function Settings24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M23 13.4v-2.8l-3-.8c-.2-.7-.5-1.4-.8-2L20.8 5l-1.9-1.9-2.8 1.6c-.6-.4-1.3-.7-2-.8l-.8-3h-2.8L9.9 4c-.7.2-1.4.5-2 .8L5.1 3.3 3.3 5.1l1.6 2.8c-.4.6-.7 1.3-.9 2l-3 .8v2.8l3 .8c.2.7.5 1.4.8 2l-1.6 2.8L5.1 21l2.8-1.6c.6.4 1.3.7 2 .8l.8 3h2.8l.8-3c.7-.2 1.4-.5 2-.8l2.8 1.6 1.9-1.9-1.6-2.8c.4-.6.7-1.3.8-2l2.8-.9zM12 17c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5-2.2 5-5 5z"
  }));
};

Settings24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "24",
  height: "24",
  focusable: "false"
};

var Share16x16 = function Share16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M16 7 8 1.29v3.14c-5 0-8 3.43-8 9.14C2.29 10.14 5.05 9 8 9v3.71Z"
  }));
};

Share16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Share24x24 = function Share24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m23 11-9-7v4h-1.83C7 8 2.71 12.56 2 18.1A1.71 1.71 0 0 0 3.44 20h.09a1.62 1.62 0 0 0 1.39-1.28c.73-2.61 4-4.72 7.82-4.72H14v4Z"
  }));
};

Share24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var ShareToCollection16x16 = function ShareToCollection16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6.14 9c.44 0 .8.33.85.75l.01.1v4.3a.86.86 0 0 1-.74.84l-.12.01H1.86a.86.86 0 0 1-.85-.74L1 14.14V9.86c0-.44.33-.8.75-.85l.1-.01h4.3zM12 9a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1zm-6.57 1H2.57a.57.57 0 0 0-.54.38l-.02.1-.01.09v2.86c0 .25.16.47.39.54l.09.02.09.01h2.86a.57.57 0 0 0 .54-.39l.02-.09.01-.09v-2.86a.57.57 0 0 0-.48-.56l-.1-.01zm.71-9c.44 0 .8.33.85.75l.01.1v4.3a.86.86 0 0 1-.74.84L6.14 7H1.86A.86.86 0 0 1 1 6.26L1 6.14V1.86c0-.44.33-.8.75-.85l.1-.01h4.3zm8 0c.44 0 .8.33.85.75l.01.1v4.3a.86.86 0 0 1-.74.84l-.12.01H9.86A.86.86 0 0 1 9 6.26L9 6.14V1.86c0-.44.33-.8.75-.85l.1-.01h4.3zM5.43 2H2.57a.57.57 0 0 0-.54.38l-.02.1-.01.09v2.86c0 .25.16.47.39.54l.09.02.09.01h2.86a.57.57 0 0 0 .54-.39L6 5.52 6 5.43V2.57a.57.57 0 0 0-.48-.56L5.42 2zm8 0h-2.86a.57.57 0 0 0-.54.38l-.02.1-.01.09v2.86c0 .25.16.47.39.54l.09.02.09.01h2.86a.57.57 0 0 0 .54-.39l.02-.09.01-.09V2.57a.57.57 0 0 0-.48-.56l-.1-.01z"
  }));
};

ShareToCollection16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var SortArrowDown16x16 = function SortArrowDown16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9 8V4a1 1 0 0 0-2 0v4H5l3 5 3-5Z"
  }));
};

SortArrowDown16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var SortArrowUp16x16 = function SortArrowUp16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7 8v4a1 1 0 0 0 2 0V8h2L8 3 5 8Z"
  }));
};

SortArrowUp16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Star16x16 = function Star16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m8 1 2.33 4.61 5.21.74-3.77 3.59.89 5.06L8 12.61 3.34 15l.89-5.06L.46 6.35l5.21-.74L8 1z"
  }));
};

Star16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var ThumbsUp16x16 = function ThumbsUp16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("rect", {
    x: "1",
    y: "6",
    width: "3",
    height: "9",
    rx: "1",
    ry: "1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.91 4.49.68-2.19a1 1 0 0 0-1-1.3H9.41a1 1 0 0 0-.71.29L5.64 5.18A3 3 0 0 0 5 7v6a2 2 0 0 0 2 2h5a2 2 0 0 0 1.6-.8C15.16 12.12 16 10.6 16 8V7a1 1 0 0 0-1-1h-3.23a1 1 0 0 1-.86-1.51Z"
  }));
};

ThumbsUp16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Time16x16 = function Time16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 0 8 8 8 8 0 0 0-8-8Zm3.47 11.47a1 1 0 0 1-1.41 0L7.29 8.71A1 1 0 0 1 7 8V3a1 1 0 0 1 2 0v4.59l2.47 2.47a1 1 0 0 1 0 1.41Z"
  }));
};

Time16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Undo16x16 = function Undo16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 5v1.96a.5.5 0 0 1-.81.39l-3.7-2.96a.5.5 0 0 1 0-.78L7.19.65a.5.5 0 0 1 .81.39V3a6 6 0 1 1-6 6 1 1 0 0 1 2 0 4 4 0 1 0 4-4Z"
  }));
};

Undo16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Undo20x20 = function Undo20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10 6.25v2.71a.5.5 0 0 1-.81.39L4.24 5.39a.5.5 0 0 1 0-.78L9.19.65a.5.5 0 0 1 .81.39v2.71a7.5 7.5 0 1 1-7.5 7.5 1.25 1.25 0 0 1 2.5 0 5 5 0 1 0 5-5Z"
  }));
};

Undo20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var Undo24x24 = function Undo24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 8v2.94a.75.75 0 0 1-1.22.58L5.23 7.08a.75.75 0 0 1 0-1.17l5.55-4.44a.75.75 0 0 1 1.22.59V5a9 9 0 1 1-9 9 1.5 1.5 0 0 1 3 0 6 6 0 1 0 6-6z"
  }));
};

Undo24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var Upload16x16 = function Upload16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m8 0 5 7h-3v5a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7H3Zm7 16H1a1 1 0 0 1-1-1 1 1 0 0 1 1-1h14a1 1 0 0 1 1 1 1 1 0 0 1-1 1Z"
  }));
};

Upload16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Video16x16 = function Video16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15 0H1C.4 0 0 .4 0 1v14c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-1 12H2V4h12v8zM2 1h2v2H2V1zm5 0h2v2H7V1zm5 0h2v2h-2V1zM2 13h2v2H2v-2zm5 0h2v2H7v-2zm5 0h2v2h-2v-2z"
  }));
};

Video16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Video24x24 = function Video24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M23 2H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Zm-1 16H2V6h20Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 3h2v2H2zM8 3h2v2H8zM14 3h2v2h-2zM20 3h2v2h-2zM2 19h2v2H2zM8 19h2v2H8zM14 19h2v2h-2zM20 19h2v2h-2z",
    fill: "#fff"
  }));
};

Video24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var ViewGrid24x24 = function ViewGrid24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10 11H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1Zm10-1V5a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1Zm-9 9v-5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1Zm9 0v-5a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1Z"
  }));
};

ViewGrid24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var ViewList16x16 = function ViewList16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M3 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM3 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM3 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM5 12a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1ZM5 8a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1ZM5 4a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Z"
  }));
};

ViewList16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var ViewList20x20 = function ViewList20x20(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1ZM5 8a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1ZM5 12a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1ZM5 16a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1ZM1 16a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM1 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM1 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM1 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
  }));
};

ViewList20x20.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  focusable: "false"
};

var ViewList24x24 = function ViewList24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7 6a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1zm0 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1zm0 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1zm0 4a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1zm-4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm0-4a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm0-4a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm0-4a1 1 0 1 1 2 0 1 1 0 0 1-2 0z"
  }));
};

ViewList24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};

var Visible16x16 = function Visible16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 3.43C3.58 3.43 0 8 0 8s3.58 4.57 8 4.57S16 8 16 8s-3.58-4.57-8-4.57ZM8 11a3 3 0 1 1 3-3 3 3 0 0 1-3 3Z"
  }));
};

Visible16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Warning16x16 = function Warning16x16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.64 1.18c.18.1.33.26.43.44l6.75 11.46c.36.6.16 1.38-.43 1.74a1.24 1.24 0 0 1-.64.18H1.25C.56 15 0 14.43 0 13.73c0-.23.06-.45.18-.65L6.93 1.62a1.24 1.24 0 0 1 1.71-.44zM7.99 11A1 1 0 0 0 7 12a1 1 0 0 0 1 1c.54 0 1-.46 1-1a1.02 1.02 0 0 0-1-1zm.48-6H7.5a.5.5 0 0 0-.47.44v.09l.24 4a.5.5 0 0 0 .41.46l.09.01h.48a.5.5 0 0 0 .48-.39l.02-.08.22-4.03a.5.5 0 0 0-.4-.5h-.1z"
  }));
};

Warning16x16.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  focusable: "false"
};

var Warning24x24 = function Warning24x24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.96 1.27c.27.16.49.39.65.66l10.12 17.2c.53.9.24 2.06-.65 2.6-.29.18-.62.27-.96.27H1.88A1.89 1.89 0 0 1 0 20.1c0-.34.1-.68.27-.97l10.12-17.2a1.86 1.86 0 0 1 2.57-.66zM11.99 16c-.82 0-1.49.69-1.49 1.51 0 .8.67 1.49 1.49 1.49s1.51-.69 1.51-1.49c0-.82-.69-1.51-1.51-1.51zm.74-9h-1.5a.76.76 0 0 0-.73.66v.13l.37 6a.76.76 0 0 0 .64.7l.13.01h.74a.77.77 0 0 0 .75-.58l.02-.13.35-6.04a.76.76 0 0 0-.63-.74L12.73 7z"
  }));
};

Warning24x24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  focusable: "false"
};
export { Add16x16, Add24x24, Alert16x16, Alert24x24, AlertOutline16x16, AllItems16x16, AllItems24x24, Analytics16x16, ArrowDown16x16, ArrowLeft16x16, ArrowRight16x16, ArrowUp16x16, Audio16x16, Audio20x20, Audio24x24, AudioDescription16x16, AudioDescription20x20, AudioLow16x16, AudioLow20x20, AudioMedium16x16, AudioMedium20x20, AudioMuted16x16, AudioMuted20x20, AudioMuted24x24, Calendar16x16, Calendar24x24, Camera16x16, CaptionAdd24x24, CaptionDelete24x24, CaptionSplit24x24, Captions16x16, CaratDown16x16, CaratLeft16x16, CaratRight16x16, CaratUp16x16, Checkmark16x16, CircleAdd16x16, CircleAdd24x24, CircleRemove16x16, CircleRemove24x24, Close16x16, Close20x20, Close24x24, ClosedCaption16x16, ClosedCaption20x20, ClosedCaptionNonEng16x16, ClosedCaptionNonEng20x20, ClosedCaptions16x16, Collection16x16, Comment16x16, Comment24x24, Copy16x16, Delete16x16, Document16x16, Document24x24, Documents24x24, Download16x16, Edit16x16, Ellipsis16x16, Ellipsis24x24, EllipsisStacked16x16, Emoji16x16, Folder16x16, Folder24x24, FolderAdd16x16, FolderMove16x16, Free16x16, FullscreenEnter16x16, FullscreenExit16x16, Groups16x16, Hidden16x16, Image16x16, Image24x24, Info24x24, Key16x16, Like16x16, Lock16x16, MediaControlBack16x16, MediaControlBack20x20, MediaControlBrokenPlay16x16, MediaControlBrokenPlay20x20, MediaControlForward16x16, MediaControlForward20x20, MediaControlPause16x16, MediaControlPause20x20, MediaControlPlay16x16, MediaControlPlay20x20, MediaControlSkipBack16x16, MediaControlSkipBack20x20, MediaControlSkipBack24x24, MediaControlSkipForward16x16, MediaControlSkipForward20x20, MediaControlSkipForward24x24, MediaExpand16x16, MediaExpand20x20, MediaFullFrame16x16, MediaFullFrame20x20, MediaFullscreen16x16, MediaFullscreen20x20, MediaMinimize16x16, MediaMinimize20x20, MediaMinimizeFullFrame16x16, MediaMinimizeFullFrame20x20, MediaPopout16x16, MediaPopout20x20, Playlist24x24, PrivacyLink16x16, PrivacyOrgAll16x16, PrivacyOrgLink16x16, Publish16x16, Question16x16, Quiz16x16, Redo16x16, Redo20x20, Redo24x24, Search16x16, Search20x20, Settings16x16, Settings20x20, Settings24x24, Share16x16, Share24x24, ShareToCollection16x16, SortArrowDown16x16, SortArrowUp16x16, Star16x16, ThumbsUp16x16, Time16x16, Undo16x16, Undo20x20, Undo24x24, Upload16x16, Video16x16, Video24x24, ViewGrid24x24, ViewList16x16, ViewList20x20, ViewList24x24, Visible16x16, Warning16x16, Warning24x24 };